import React, { SVGProps } from 'react'
import DustinLogoIcon from '../icon/generated/dustin-logo'
import DustinSymbolIcon from '../icon/generated/dustin-symbol'

interface Props extends SVGProps<SVGSVGElement> {
  onlySymbol?: boolean
  className?: string
}

export const DustinLogo = ({ onlySymbol = false, className, ...props }: Props) => {
  if (!onlySymbol) {
    return <DustinLogoIcon {...props} name="dustin-logo" className={`u-h-auto ${className}`} />
  } else {
    return <DustinSymbolIcon {...props} name="dustin-symbol" className={`u-h-auto ${className}`} />
  }
}

export default DustinLogo
